import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import extensions from '@/extensions';
import LoginView from '@/components/LoginView';
import GameListPage from '@/components/GameListPage';
import GamePage from '@/components/GamePage';
import SignInPage from '@/components/SignInPage';
import RegisterPage from '@/components/RegisterPage';
import ForgotPasswordPage from '@/components/ForgotPasswordPage';
import AccountPage from '@/components/AccountPage';
import CreateGamePage from '@/components/CreateGamePage';
import AdminPage from '@/components/AdminPage';
import InvitationPage from '@/components/InvitationPage';
import SettingsPage from '@/components/SettingsPage';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    // Signed in, the game list is the start page (SPEC §4.2).
    { path: '/', name: 'root', component: LoginView,
      beforeEnter: (to, from, next) => (store.state.user ? next({ name: 'list' }) : next()) },
    { path: '/games', name: 'list', component: GameListPage, meta: { auth: true } },
    { path: '/games/new', name: 'create-game', component: CreateGamePage, meta: { auth: true } },
    { path: '/games/:id', name: 'game', component: GamePage, meta: { auth: true } },
    { path: '/signin', name: 'signin', component: SignInPage },
    { path: '/register', name: 'register', component: RegisterPage },
    { path: '/register/verify', name: 'register-verify', component: RegisterPage },
    { path: '/forgot-password', name: 'forgot-password', component: ForgotPasswordPage },
    { path: '/account', name: 'account', component: AccountPage, meta: { auth: true } },
    { path: '/settings', name: 'settings', component: SettingsPage, meta: { auth: true } },
    // Readable without sign-in; accepting signs in first (SPEC §4.14).
    { path: '/invitations/:id', name: 'invitation', component: InvitationPage },
    // The admin zone has its own sign-in (SPEC §4.13), not the player's.
    { path: '/admin', name: 'admin', component: AdminPage },
  ]
});

// Where a signed-out visitor starts signing in: with a module's sign-in provider (WeChat inside
// WeChat), these sign in through it at once, then open ?next= or the game list (SPEC §4.1).
const SIGN_IN_ENTRIES = ['root', 'signin', 'register'];

// Pages that need sign-in send signed-out visitors to sign-in first, and back afterwards; a sign-in
// provider of a module (e.g. WeChat inside WeChat) takes over when it is available.
router.beforeEach((to, from, next) => {
  if (store.state.user) return next();
  const entry = SIGN_IN_ENTRIES.includes(to.name);
  if (!to.meta.auth && !entry) return next();
  const provider = extensions.signInProviders.find(p => p.available());
  if (provider) {
    next(false);
    provider.signIn(entry ? (to.query.next || '/games') : to.fullPath);
  } else if (entry) {
    next();
  } else {
    next({ name: 'signin', query: { next: to.fullPath } });
  }
});

export default router;
